module.exports = __webpack_public_path__ + "assets/overview-loop.fc4df7d9.svg";